import { apiClient } from "@/lib/api/client";

export interface SearchGeoResultItem {
  domain: "all" | "professionals" | "clinics" | "services" | "posts" | "medimarket" | "jobs" | "events";
  id: string;
  title: string;
  subtitle: string | null;
  url: string | null;
  slug: string | null;
  image_url: string | null;
  business_id: number | null;
  service_id: number | null;
  is_verified:  boolean;
  is_sponsored: boolean;
  rating: number | null;
  distance_km: number | null;
  lat: number | null;
  lng: number | null;
  languages: string[];
  gender: string | null;
  phone: string | null;
  location_label: string | null;
  today_hours: string | null;
  score: {
    text_match: number;
    geo_match: number;
    quality: number;
    freshness: number;
    total: number;
  };
}

export interface SearchGeoResponse {
  meta: {
    page: number;
    page_size: number;
    total_estimate: number | null;
    has_more: boolean;
  };
  results: SearchGeoResultItem[];
}

export interface SearchGeoParams {
  q?:          string;
  city?:       string;
  category?:   string[];
  lat?:        number | null;
  lng?:        number | null;
  radius_km?:  number;
  gender?:     "female" | "male" | "any";
  is_verified?: boolean;
  rating_min?: number;
  page?:       number;
  page_size?:  number;
  domain?:     "all" | "professionals" | "clinics" | "services" | "posts";
}

export const getGeoSearchResults = async (params: SearchGeoParams): Promise<SearchGeoResponse> => {
  const response = await apiClient.get<SearchGeoResponse>("/search", { params });
  return response.data;
};

export const getPublicProfessionalSpecializations = async (): Promise<string[]> => {
  const response = await apiClient.get<string[]>("/search/professional-specializations");
  return response.data;
};
